import React, { useState, useEffect, useContext, useRef } from "react";
import user from "../assets/media/images/user2.png";
import { AppContext } from "../AppContextProvider";
import CircleProgressComponent from "../components/graph/CircleProgressComponent";

import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBRow,
  MDBCol,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
} from "mdb-react-ui-kit";

export default function CategoriesModalTest(props) {
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const [activeTab, setActiveTab] = useState("");

  const categoriesMap = props.modalParam.nodes
    .filter((k) => k.level === 1)
    .filter((k) => k.value2 !== "dataOwnerFiles")
    .map((k) => {
      return { filter: k.value2, category: k.label };
    });
  const fullProcess = 500;
  const process1 = Math.max(
    ((props.modalParam.nodes
      .filter((k) => k.cid === 2)
      .filter((k) => k._type?.split("/")[k._type?.split("/").length - 1] !== "seriesDataPoint").length -
      1) *
      100) /
      fullProcess,
    1,
  );
  const process2 = Math.max(((props.modalParam.nodes.filter((k) => k.cid === 3).length - 1) * 100) / fullProcess, 1);
  const process3 = Math.max(((props.modalParam.nodes.filter((k) => k.cid === 4).length - 1) * 100) / fullProcess, 1);
  const process4 = Math.max(((props.modalParam.nodes.filter((k) => k.cid === 5).length - 1) * 100) / fullProcess, 1);
  const process5 = Math.max(((props.modalParam.nodes.filter((k) => k.cid === 6).length - 1) * 100) / fullProcess, 1);
  const process6 = Math.max(
    ((props.modalParam.nodes
      .filter((k) => k.cid === 7)
      .filter((k) => k._type?.split("/")[k._type?.split("/").length - 1] !== "seriesDataPoint").length -
      1) *
      100) /
      fullProcess,
    1,
  );
  const process7 = Math.max(
    ((props.modalParam.nodes
      .filter((k) => k.cid === 8)
      .filter((k) => k._type?.split("/")[k._type?.split("/").length - 1] !== "seriesDataPoint").length -
      1) *
      100) /
      fullProcess,
    1,
  );
  const process8 = Math.max(((props.modalParam.nodes.filter((k) => k.cid === 9).length - 1) * 100) / fullProcess, 1);

  const categoriesArray = [
    {
      name: categoriesMap.length > 0 ? categoriesMap[0].filter : "n.d.",
      process: process1,
      primaryColor:
        categoriesMap.length > 0
          ? isDark
            ? ["#ffb8e0", "#3c002b"]
            : ["#ffe5f4", "#770059"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 0 ? "var(--nc-320-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 0 ? "var(--nc-320-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 1 ? categoriesMap[1].filter : "n.d.",
      process: process2,
      primaryColor:
        categoriesMap.length > 1
          ? isDark
            ? ["#ffb693", "#351000"]
            : ["#ffe7db", "#6a2800"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 1 ? "var(--nc-020-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 1 ? "var(--nc-020-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 2 ? categoriesMap[2].filter : "n.d.",
      process: process3,
      primaryColor:
        categoriesMap.length > 2
          ? isDark
            ? ["#3affb2", "#002012"]
            : ["#c7ffe9", "#004b30"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 2 ? "var(--nc-160-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 2 ? "var(--nc-160-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 3 ? categoriesMap[3].filter : "n.d.",
      process: process4,
      primaryColor:
        categoriesMap.length > 3
          ? isDark
            ? ["#71d1ff", "#001d2e"]
            : ["#cceeff", "#00405d"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 3 ? "var(--nc-200-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 3 ? "var(--nc-200-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 4 ? categoriesMap[4].filter : "n.d.",
      process: process5,
      primaryColor:
        categoriesMap.length > 4
          ? isDark
            ? ["#bdbdff", "#130a66"]
            : ["#e5e5ff", "#2118a5"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 4 ? "var(--nc-240-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 4 ? "var(--nc-240-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 5 ? categoriesMap[5].filter : "n.d.",
      process: process6,
      primaryColor:
        categoriesMap.length > 5
          ? isDark
            ? ["#e9b8ff", "#310049"]
            : ["#f7e5ff", "#63008e"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 5 ? "var(--nc-280-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 5 ? "var(--nc-280-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 6 ? categoriesMap[6].filter : "n.d.",
      process: process7,
      primaryColor:
        categoriesMap.length > 6
          ? isDark
            ? ["#b7f732", "#131f00"]
            : ["#e1fea5", "#324800"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 6 ? "var(--nc-080-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 6 ? "var(--nc-080-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: categoriesMap.length > 7 ? categoriesMap[7].filter : "n.d.",
      process: process2,
      primaryColor:
        categoriesMap.length > 7
          ? isDark
            ? ["#77f875", "#002103"]
            : ["#cdffcc", "#004d0c"]
          : isDark
            ? ["#1f2233", "#1f2233"]
            : ["#f1f2f6", "#f1f2f6"],
      color: categoriesMap.length > 7 ? "var(--nc-120-5)" : "var(--background-brand-primary-alt)",
      background: categoriesMap.length > 7 ? "var(--nc-120-10)" : "var(--background-brand-maxi-hover)",
    },
    {
      name: "n.d.",
      process: 1,
      primaryColor: isDark ? ["#1f2233", "#1f2233"] : ["#f1f2f6", "#f1f2f6"],
      color: "var(--background-brand-primary-alt)",
      background: "var(--background-brand-maxi-hover)",
    },
  ];

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <>
      <MDBModal staticBackdrop tabIndex="-1" closeOnEsc={false} show={props.visible} className="catgories-modal">
        <MDBModalDialog centered size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <div className="title-text">Digital twin dashboard</div>
              <button
                type="button"
                className="button subtle medium"
                onClick={() => props.hideModal()}
                style={{ minWidth: "unset" }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.70703 8L13.8535 2.85352C14.0488 2.6582 14.0488 2.3418 13.8535 2.14648C13.6582 1.95117 13.3418 1.95117 13.1465 2.14648L8 7.29297L2.85352 2.14648C2.6582 1.95117 2.3418 1.95117 2.14648 2.14648C1.95117 2.3418 1.95117 2.6582 2.14648 2.85352L7.29297 8L2.14648 13.1465C1.95117 13.3418 1.95117 13.6582 2.14648 13.8535C2.24414 13.9512 2.37207 14 2.5 14C2.62793 14 2.75586 13.9512 2.85352 13.8535L8 8.70703L13.1465 13.8535C13.2441 13.9512 13.3721 14 13.5 14C13.6279 14 13.7559 13.9512 13.8535 13.8535C14.0488 13.6582 14.0488 13.3418 13.8535 13.1465L8.70703 8Z"
                    fill="var(--text-brand-secondary)"
                  />
                </svg>
              </button>
            </MDBModalHeader>
            <MDBModalBody>
              <div className="dwin-figur-col">
                <img className="human-image" src={user} alt="worldmap" />
              </div>
              <div className="category-symbole-col">
                <div className="category-row">
                  {categoriesArray.map((k, n) => {
                    return (
                      <div
                        key={n}
                        className="category-symbole"
                        style={{
                          borderColor: k.color,
                          background: activeTab === k.name ? k.background : "var(--background-brand-maxi-hover)",
                        }}
                        onClick={() => setActiveTab(k.name)}
                      >
                        <span className="category-name" style={{ color: k.color }}>
                          {k.name}
                        </span>
                        <CircleProgressComponent
                          percentage={Math.min(k.process, 100)}
                          primaryColor={k.primaryColor}
                          height={"85px"}
                          width={"85px"}
                          widthNumber={85}
                          strokeWidth={10}
                        />
                        <span className="category-process" style={{ color: k.color }}>
                          {k.process - 1 + "%"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}
